import React, { useEffect, useState } from "react";
import {
  Container,
  Button,
  Row,
  Col,
  Form,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
// import { InfoCircle } from "react-bootstrap-icons";
import axios from "axios";
import Header from "../components/LoanUnderwrite/Header";
import Steps from "../components/LoanUnderwrite/Steps";
import UnderwriteLoan from "./UnderwriteLoan.jsx";
import UserService from "../services/UserService";
import { MDBDataTable } from "mdbreact";
import ContentPage from "./ContentPage";
import LeftNav from "../components/LeftNav.jsx";
import RightAside from "./../components/RightAside";
import { logWorkflowAction } from "../utils/workflowLogger";

const serverConfig = require("../config/server.js");

const LoanCalculate = () => {
  const [token, setToken] = useState(null);
  const [errors, setErrors] = useState({});
  const [company, setCompany] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [currentStep, setCurrentStep] = useState("Loans");
  const isReadOnly = currentStep === "Review";

  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");

  const handleLogout = () => {
    sessionStorage.clear();
    UserService.doLogout();
  };

  const getToken = () => {
    console.log(sessionStorage.getItem("token"));
    let jwt = UserService.getToken();
    axios.post(serverConfig.api_base_url + "user_sync_from_sso", { jwt: jwt }).catch((error) => {
      console.log("user_sync_from_sso response", error);
    });
    axios
      .post(serverConfig.api_base_url + "user_get_token", { jwt: jwt })
      .then((response) => {
        console.log("user_get_token response", response);
        if (response.data.status === 200) {
          sessionStorage.setItem("token", response.data.token);
          setToken(response.data.token);
        } else if (response.data.status >= 400 && response.data.status <= 499) {
          alert(response.data.message);
        } else if (response.data.jwt_validation === "fail") {
          handleLogout();
        }
      })
      .catch((err) => console.log("error is", err));
  };

  useEffect(() => {
    console.log(sessionStorage.getItem("token"));
    if (sessionStorage.getItem("token") === null) {
      getToken();
    } else {
      setToken(sessionStorage.getItem("token"));
    }
  }, []);

  // LoanTable related
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState(null);
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${serverConfig.api_base_url}underwriting-engine/loans?search=${searchTerm}`
      );
      const json = await response.json();

      if (json.status === "success" && Array.isArray(json.data)) {
        console.log("Loan data fetched successfully:", json.data);
        const rows = json.data.map((row) => ({
          applicationNumber: row["Application Number"],
          submitDate: row["Submit Date"].split("T")[0],
          loanAmount: `$${parseFloat(row["Submit Cost"]).toFixed(2)}`,
          assetType: row["Asset Type"],
          officeName: row["Office Name"],
          action: (
            <Button
              variant="transparent"
              className=""
              type="submit"
              onClick={() => {
                handleLoanProcess(row["Application Number"]);
              }}
            >
              Process Loan
            </Button>
          ),
        }));

        setTableData({
          columns: [
            {
              label: "Application Number",
              field: "applicationNumber",
              sort: "asc",
            },
            {
              label: "Submit Date",
              field: "submitDate",
              sort: "asc",
            },
            {
              label: "Loan Amount",
              field: "loanAmount",
              sort: "asc",
            },
            {
              label: "Asset Type",
              field: "assetType",
              sort: "asc",
            },
            {
              label: "Office Name",
              field: "officeName",
              sort: "asc",
            },
            {
              label: "Action",
              field: "action",
              sort: "disabled",
            },
          ],
          rows,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const assetTypes = [
    "DRNK",
    "ADIA",
    "ICEM",
    "PRNT",
    "LOAD",
    "FORK",
    "CNST",
    "EXCV",
    "HVAC",
    "TTLV",
    "CCTV",
    "CNCM",
    "ALFT",
    "OFEQ",
    "SWAR",
    "GYM",
    "REST",
    "AIRD",
    "PRNM",
    "FONE",
    "REFR",
    "WELD",
    "GRIN",
    "XRAY",
    "MLAS",
    "FURN",
    "DISH",
    "LAWN",
    "EMBR",
    "CMPC",
    "ACQU",
    "MEFB",
    "MEDI",
    "INEQ",
    "DMED",
    "BEAU",
    "SLIT",
    "LEAS",
    "COMP",
    "CANO",
    "MILL",
    "MANU",
    "LAB",
    "FOOD",
    "AV",
    "INFL",
    "FLSW",
    "GASP",
    "POS",
    "SAWS",
    "MFRM",
    "WHAL",
    "COPY",
    "WATT",
    "SERV",
    "PACK",
    "AIRC",
    "WOOD",
    "ENGR",
    "RETC",
    "WATC",
    "FRAL",
    "LOGG",
    "FRCH",
    "SIGN",
    "SLPR",
    "IRRI",
    "AIRP",
    "PNT",
    "METL",
    "TENT",
    "PAVE",
    "ALRM",
    "GEN",
    "LAMN",
    "DUMP",
    "PRES",
    "SPRT",
    "CLNR",
    "IPRT",
    "DENT",
    "DOZE",
    "GPS",
    "TAN",
    "LITU",
    "FARM",
    "PALT",
    "WATP",
    "WDRY",
    "FOTO",
    "MOBR",
    "MALT",
    "SAFE",
    "HYMS",
    "MLAT",
    "PSHR",
    "SCAL",
    "ROLL",
    "CRPT",
    "SURV",
    "CNVY",
    "TRSH",
    "ACCE",
    "SCRN",
    "CHAI",
    "SCAN",
    "EPPA",
    "REFU",
    "DYNO",
    "ULTS",
    "VEND",
    "MUSC",
    "LBLI",
    "ALCH",
    "PORT",
    "OFPT",
    "TV",
    "PLMB",
    "SURG",
    "TRDB",
    "CADD",
    "BOWL",
    "CREM",
    "PBLD",
    "BRKL",
    "CLAU",
    "MELR",
    "MAIL",
    "INSU",
    "TOWH",
    "UNKN",
    "PAGE",
    "ARCH",
    "HYDR",
  ];

  const officeName = [
    "Partner Funding - Credit",
    "Strategic Accounts",
    "End User Channel",
    "Dealer Services",
    "Partner Funding - Asset",
    "Copier",
    "Healthcare",
    "Specialty Vehicles",
    "NSC NE",
    "UCB EF",
    "Franchise Finance",
    "Navitas Capital",
    "Enterprise Dealer",
    "PFC Franchise",
  ];

  const handleLoanProcess = async (applicationNumber) => {
    setIsLoading(true);
    const res = await fetch(
      `${serverConfig.api_base_url}underwriting-engine/loans/${applicationNumber}`
    );
    const json = await res.json();
    setIsLoading(false);
    console.log(json);

    if (json.status === "success") {
      const mappedData = {
        applicationNumber: json.data["Application Number"],
        nameOfBusiness: json.data["Name of Business"],
        officeName: json.data["Office Name"],
        loanAmount: json.data["Submit Cost"],
        assetType: json.data["Asset Type"],
        city: json.data["Customer Billing City"],
        submitDate: json.data["Submit Date"],

        highCredit: json.data["AVG_HI_CREDIT"],
        maxHighCredit: json.data["HIGH_CREDIT"],
        numberOfEmployees: json.data["EMP_TOT"],
        birthyear: json.data["BIRTHYEAR"],
        commercialCreditScore: json.data["COM_CRE_SCORE"],
        timeInBusiness: json.data["LW_YRS_IN_BUS"],
        standardCode: json.data["SIC_PRI"],
        startYear: json.data["START_YEAR"],
        noOfInquiries: json.data["NUM_INQ"],
        noOfTradeExperiences: json.data["NUM_TRADE_EXP"],
        pnMasterScore: json.data["PN_MASTER_SCR"],
        paydex: json.data["PAYDEX_FIRM"],
        vantage: json.data["VANTAGE"],
        noOfSatisfactoryAccounts: json.data["SATACCTS"],
        noOfTotalDelinquencies: json.data["WASDELINQ"],
        noOfDelinquencies: json.data["NUMDELINQ"],
        suits: json.data["SUITS"],
        liens: json.data["LIENS"],
        judgements: json.data["JUDGEMENTS"],
        fico: json.data["FICO_AVG"],
        maxFico: json.data["FICO_MAX"],
        fico2: json.data["FICO2"],
        noOfGuarantors: json.data["GRNTRS"],
        bankruptcy: json.data["BANKRUPTCY"],
        totalRevolvingBalance: json.data["TOTREV_BAL"],
        totalRevolvingAvailable: json.data["TOTREV_AVAIL"],
        realStateBalance: json.data["RE_BAL"],
        yield: json.data["Yield_cw"],

        actualRating: json.data["Risk Rating"],
        actualScore: "NA",
        isNewApplication: false,
      };
      // decide switches right here
      let useCorpSwitch = false;
      let usePGSwitch = false;

      if (mappedData.noOfGuarantors > 0) {
        usePGSwitch = true;
      } else {
        useCorpSwitch = true;
      }

      setInputs({
        ...initialInputs,
        ...mappedData,
        useCorpSwitch,
        usePGSwitch,
      });

      try {
        await logWorkflowAction(applicationNumber, "process", {
          ...initialInputs,
          ...mappedData,
          useCorpSwitch,
          usePGSwitch,
        });
      } catch (error) {
        console.error("Error logging process loan action:", error);
      }

      // Store initial values for change tracking
      setInitialValues(mappedData);

      // Trigger handleChange manually for auto-updated fields
      const autoUpdateFields = [
        "timeInBusiness",
        "fico",
        "numberOfEmployees",
        "highCredit",
        "paydex",
        "noOfTradeExperiences",
      ];

      autoUpdateFields.forEach((field) => {
        handleChange({
          target: {
            name: field,
            type: "number",
            value: mappedData[field],
          },
        });
      });
      setCurrentStep("Application");
    } else {
      setAlertMsg("Failed to fetch loan details");
      setShowAlert(true);
    }
  };

  const initialInputs = {
    // Mark as new
    isNewApplication: true,

    // Main Loan Details
    applicationNumber: "",
    nameOfBusiness: "",
    officeName: "",
    loanAmount: "",
    assetType: "",
    city: "",

    // Bureau Details
    highCredit: "",
    maxHighCredit: "",
    bankruptcy: "",
    birthyear: "",
    commercialCreditScore: "",
    numberOfEmployees: "",
    fico: "",
    maxFico: "",
    fico2: "",
    noOfGuarantors: "",
    noOfCorpGuarantors: "",
    suits: "",
    liens: "",
    judgements: "",
    timeInBusiness: "",
    noOfDelinquencies: "",
    noOfInquiries: "",
    noOfTradeExperiences: "",
    paydex: "",
    pnMasterScore: "",
    pnHighCredit: "",
    pnNoOfTradeExperiences: "",
    realStateBalance: "",
    noOfSatisfactoryAccounts: "",
    standardCode: "",
    startYear: "",
    totalRevolvingBalance: "",
    totalRevolvingAvailable: "",
    vantage: "",
    noOfTotalDelinquencies: "",
    yield: "",

    // Personal Guarantor (PG) Details
    pgTimeInBusiness: "",
    pgFicoScore: "",
    pgStrongPaymentHistorySwitch: false,
    pgStrongPaymentHistorySwitchPoints: 2,
    pgAcceptableCreditHistorySwitch: false,
    pgAcceptableCreditHistorySwitchPoints: 1,
    pgStrongComparibleCreditSwitch: false,
    pgStrongComparibleCreditSwitchPoints: 2,
    pgAcceptableComparibleCreditSwitch: false,
    pgAcceptableComparibleCreditSwitchPoints: 1,
    pgPreferredCollateralSwitch: false,
    pgPreferredCollateralSwitchPoints: 1,
    pgSoftCollateralSwitch: false,
    pgSoftCollateralSwitchPoints: -1,
    pgIntangiblesSwitch: false,
    pgIntangiblesPoints: 0,
    pgOverrideSwitch: false,
    pgOverridePoints: 0,
    pgOverrideText: "",
    pgVendorCheck: false,

    // Corporation Details
    corpTimeInBusiness: "",
    corpTimeInBusinessPoints: 0,
    corpNumberOfEmployees: "",
    corpNumberOfEmployeesPoints: 0,
    corpHighCredit: "",
    corpHighCreditPoints: 0,
    corpPaydex: "",
    corpPaydexPoints: -1,
    corpTradeLines: "",
    corpTradeLinesPoints: 0,
    suitsLiensJudgements: "",
    suitsLiensJudgementsPoints: 1,
    historyClearSwitch: false,
    historyClearPoints: 1,
    uccFilingsSwitch: false,
    uccFilingsPoints: 1,
    highRiskIndustrySwitch: false,
    highRiskIndustryPoints: -1,
    comparableLeaseSwitch: false,
    comparableLeasePoints: 1,
    majorityEquitySingleOwnershipSwitch: false,
    majorityEquitySingleOwnershipPoints: -2,
    preferredCollateralSwitch: false,
    preferredCollateralPoints: 1,
    softCollateralSwitch: false,
    softCollateralPoints: -1,
    intangiblesSwitch: false,
    intangiblesPoints: 0,
    overrideSwitch: false,
    overridePoints: 0,
    overrideText: "",
    anyMajorDerog: false,
    vendorCheck: false,

    // Ratings
    pgScore: 0,
    pgRating: "C",
    corpScore: 0,
    corpRating: "C",
    actualRating: "",
    actualScore: "",
    usePGSwitch: false,
    useCorpSwitch: false,

    // Rule Overrides
    fieldsModified: 0,
    requiresPersonalGuarantor: 0,
    corpThreeOfFourCriteriaFailed: 0,
    corpOneOfTwoCriteriaFailed: 0,
    loanShortfallSupportFailed: 0,
  };

  const [inputs, setInputs] = useState(initialInputs);

  const calculateTotalPGPoints = () => {
    let total = 0;

    // For switches — only count if switch is true
    if (inputs.pgStrongPaymentHistorySwitch) {
      total += Number(inputs.pgStrongPaymentHistorySwitchPoints) || 0;
    }
    if (inputs.pgAcceptableCreditHistorySwitch) {
      total += Number(inputs.pgAcceptableComparibleCreditSwitchPoints) || 0;
    }
    if (inputs.pgStrongComparibleCreditSwitch) {
      total += Number(inputs.pgStrongComparibleCreditSwitchPoints) || 0;
    }
    if (inputs.pgAcceptableComparibleCreditSwitch) {
      total += Number(inputs.pgAcceptableComparibleCreditSwitchPoints) || 0;
    }
    if (inputs.pgPreferredCollateralSwitch) {
      total += Number(inputs.pgPreferredCollateralSwitchPoints) || 0;
    }
    if (inputs.pgSoftCollateralSwitch) {
      total += Number(inputs.pgSoftCollateralSwitchPoints) || 0;
    }
    if (inputs.pgIntangiblesSwitch) {
      total += Number(inputs.pgIntangiblesPoints) || 0;
    }
    if (inputs.pgOverrideSwitch) {
      total += Number(inputs.pgOverridePoints) || 0;
    }

    inputs.pgScore = total;

    if (total >= 4) {
      inputs.pgRating = "A/A1/A Preferred";
    } else if (total >= 3) {
      inputs.pgRating = "B1";
    } else if (total >= 2) {
      inputs.pgRating = "B2/B3";
    } else {
      inputs.pgRating = "C";
    }

    console.log("pg points", inputs.pgScore);
    console.log("pg rating", inputs.pgRating);
  };

  const calculateTotalCorpPoints = () => {
    let total = 0;

    if (inputs.corpTimeInBusiness) {
      total += Number(inputs.corpTimeInBusinessPoints) || 0;
    }
    if (inputs.corpNumberOfEmployees) {
      total += Number(inputs.corpNumberOfEmployeesPoints) || 0;
    }
    if (inputs.corpHighCredit) {
      total += Number(inputs.corpHighCreditPoints) || 0;
    }

    total += Number(inputs.corpPaydexPoints) || 0;

    if (inputs.corpTradeLines) {
      total += Number(inputs.corpTradeLinesPoints) || 0;
    }

    if (inputs.suitsLiensJudgements == "any") {
      total += 0;
    } else if (inputs.suitsLiensJudgements == "material") {
      total -= 3;
    } else {
      total += 1;
    }

    if (inputs.historyClearSwitch) {
      total += Number(inputs.historyClearPoints) || 0;
    }
    if (inputs.uccFilingsSwitch) {
      total += Number(inputs.uccFilingsPoints) || 0;
    }
    if (inputs.highRiskIndustrySwitch) {
      total += Number(inputs.highRiskIndustryPoints) || 0;
    }
    if (inputs.comparableLeaseSwitch) {
      total += Number(inputs.comparableLeasePoints) || 0;
    }
    if (inputs.majorityEquitySingleOwnershipSwitch) {
      total += Number(inputs.majorityEquitySingleOwnershipPoints) || 0;
    }
    if (inputs.preferredCollateralSwitch) {
      total += Number(inputs.preferredCollateralPoints) || 0;
    }
    if (inputs.softCollateralSwitch) {
      total += Number(inputs.softCollateralPoints) || 0;
    }
    if (inputs.intangiblesSwitch) {
      total += Number(inputs.intangiblesPoints) || 0;
    }
    if (inputs.overrideSwitch) {
      total += Number(inputs.overridePoints) || 0;
    }

    inputs.corpScore = total;

    if (inputs.loanAmount < 100000) {
      if (total >= 10) {
        inputs.corpRating = "A1";
      } else if (total >= 9) {
        inputs.corpRating = "B1";
      } else if (total >= 8) {
        inputs.corpRating = "B2";
      } else {
        inputs.corpRating = "C";
        console.log("corp points", total);
        console.log("corp rating", inputs.corpRating);
        return;
      }
    } else {
      if (total >= 10) {
        inputs.corpRating = "A1";
      } else {
        inputs.corpRating = "C";
        console.log("corp points", total);
        console.log("corp rating", inputs.corpRating);
        return;
      }

      let qualifyingCriteria = 0;
      if (inputs.corpNumberOfEmployees >= 50) {
        qualifyingCriteria += 1;
      }
      if (inputs.corpTimeInBusiness >= 10) {
        qualifyingCriteria += 1;
      }
      if (inputs.corpPaydex >= 70) {
        qualifyingCriteria += 1;
      }
      if (inputs.corpTradeLines >= 5) {
        qualifyingCriteria += 1;
      }

      if (qualifyingCriteria >= 3) {
        inputs.corpRating = "A1";
      } else {
        inputs.corpRating = "C";
        console.log("corp points", total);
        console.log("corp rating", inputs.corpRating);
        return;
      }

      if (Number(inputs.corpHighCredit) >= Number(inputs.loanAmount)) {
        inputs.corpRating = "A1";
      } else {
        if (
          Number(inputs.pgFicoScore) > 725 &&
          (Number(inputs.realStateBalance) > 0.75 * Number(inputs.loanAmount) ||
            Number(inputs.totalRevolvingBalance) >
              0.75 * Number(inputs.loanAmount))
        ) {
          inputs.corpRating = "A1";
        } else {
          inputs.corpRating = "C";
          console.log("corp points", total);
          console.log("corp rating", inputs.corpRating);
          return;
        }
      }
    }
    console.log("corp points", total);
    console.log("corp rating", inputs.corpRating);
  };

  useEffect(() => {
    calculateTotalPGPoints();
    calculateTotalCorpPoints();
  }, [inputs]);

  const [selectedType, setSelectedType] = useState("");

  const handleTypeChange = (event) => {
    const value = event.target.value;
    setSelectedType(value);
  };

  let el = document.querySelectorAll("input[required]");

  const handleChange = (event) => {
    const { name, type, value, checked } = event.target;
    const newValue = type === "checkbox" || type === "switch" ? checked : value;

    // Track changes if this is not the initial load and the field exists in initialValues
    if (Object.keys(initialValues).length > 0 && name in initialValues) {
      if (initialValues[name] != newValue) {
        setModifiedFields((prev) => ({
          ...prev,
          [name]: {
            previousVal: initialValues[name],
            newVal: newValue,
            label: name.split(/(?=[A-Z])/).join(" "),
          },
        }));
      } else {
        // If value matches initial, remove from modified fields
        setModifiedFields((prev) => {
          const newFields = { ...prev };
          delete newFields[name];
          return newFields;
        });
      }
    }

    setInputs((prevInputs) => {
      const newValue =
        type === "checkbox" || type === "switch" ? checked : value;
      let updated = { ...prevInputs, [name]: newValue };

      // Auto-update pg fields
      if (name === "timeInBusiness") {
        updated.pgTimeInBusiness = value;
      }

      if (name === "fico") {
        updated.pgFicoScore = value;
      }

      // Auto-update corp fields
      if (name === "timeInBusiness") {
        updated.corpTimeInBusiness = value;
        const corpTimeInBusiness = Number(value);
        if (corpTimeInBusiness > 5) {
          updated.corpTimeInBusinessPoints = 2;
        } else if (corpTimeInBusiness >= 4) {
          updated.corpTimeInBusinessPoints = 1;
        } else {
          updated.corpTimeInBusinessPoints = 0;
        }
      }

      if (name === "numberOfEmployees") {
        updated.corpNumberOfEmployees = value;
        const corpNumberOfEmployees = Number(value);
        if (corpNumberOfEmployees >= 20) {
          updated.corpNumberOfEmployeesPoints = 2;
        } else if (corpNumberOfEmployees >= 10) {
          updated.corpNumberOfEmployeesPoints = 1;
        } else {
          updated.corpNumberOfEmployeesPoints = 0;
        }
      }

      if (name === "highCredit") {
        updated.corpHighCredit = value;
        const corpHighCredit = Number(value);
        if (corpHighCredit >= 10000) {
          updated.corpHighCreditPoints = 2;
        } else if (corpHighCredit >= 2500) {
          updated.corpHighCreditPoints = 1;
        } else {
          updated.corpHighCreditPoints = 0;
        }
      }

      if (name === "paydex") {
        updated.corpPaydex = value;
        const corpPaydex = Number(value);
        if (corpPaydex >= 70) {
          updated.corpPaydexPoints = 2;
        } else if (corpPaydex >= 60) {
          updated.corpPaydexPoints = 1;
        } else {
          updated.corpPaydexPoints = -1;
        }
      }

      if (name === "noOfTradeExperiences") {
        updated.corpTradeLines = value;
        const corpTradeLines = Number(value);
        if (corpTradeLines >= 10) {
          updated.corpTradeLinesPoints = 2;
        } else if (corpTradeLines >= 5) {
          updated.corpTradeLinesPoints = 1;
        } else {
          updated.corpTradeLinesPoints = 0;
        }
      }

      // Points calculation logic
      if (name === "corpTimeInBusiness") {
        const corpTimeInBusiness = Number(value);
        if (corpTimeInBusiness > 5) {
          updated.corpTimeInBusinessPoints = 2;
        } else if (corpTimeInBusiness >= 4) {
          updated.corpTimeInBusinessPoints = 1;
        } else {
          updated.corpTimeInBusinessPoints = 0;
        }
      }
      if (name === "corpHighCredit") {
        const corpHighCredit = Number(value);
        if (corpHighCredit >= 10000) {
          updated.corpHighCreditPoints = 2;
        } else if (corpHighCredit >= 2500) {
          updated.corpHighCreditPoints = 1;
        } else {
          updated.corpHighCreditPoints = 0;
        }
      }
      if (name === "corpNumberOfEmployees") {
        const corpNumberOfEmployees = Number(value);
        if (corpNumberOfEmployees >= 20) {
          updated.corpNumberOfEmployeesPoints = 2;
        } else if (corpNumberOfEmployees >= 10) {
          updated.corpNumberOfEmployeesPoints = 1;
        } else {
          updated.corpNumberOfEmployeesPoints = 0;
        }
      }
      if (name === "corpPaydex") {
        const corpPaydex = Number(value);
        if (corpPaydex >= 70) {
          updated.corpPaydexPoints = 2;
        } else if (corpPaydex >= 60) {
          updated.corpPaydexPoints = 1;
        } else {
          updated.corpPaydexPoints = -1;
        }
      }
      if (name === "corpTradeLines") {
        const corpTradeLines = Number(value);
        if (corpTradeLines >= 10) {
          updated.corpTradeLinesPoints = 2;
        } else if (corpTradeLines >= 5) {
          updated.corpTradeLinesPoints = 1;
        } else {
          updated.corpTradeLinesPoints = 0;
        }
      }
      if (name === "suitsLiensJudgements") {
        const suitsLiensJudgements = value;
        if (suitsLiensJudgements === "any") {
          updated.suitsLiensJudgementsPoints = 0;
        } else if (suitsLiensJudgements === "material") {
          updated.suitsLiensJudgementsPoints = -3;
        } else {
          updated.suitsLiensJudgementsPoints = 1;
        }
      }

      // pg or corp switch
      if (name === "useCorpSwitch" && checked) {
        updated.usePGSwitch = false;
      }
      if (name === "usePGSwitch" && checked) {
        updated.useCorpSwitch = false;
      }
      if (name === "useCorpSwitch" && !checked && inputs.noOfGuarantors < 1) {
        updated.useCorpSwitch = true;
      }
      if (name === "useCorpSwitch" && !checked && inputs.noOfGuarantors >= 1) {
        updated.usePGSwitch = true;
      }
      if (name === "usePGSwitch" && !checked) {
        updated.useCorpSwitch = true;
      }

      console.log(updated);

      return updated;
    });

    setInputs((stateInputs) => {
      if (Object.keys(stateInputs).length === el.length - 1) {
        // do something here if we have extra logic
      }
      return stateInputs;
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(inputs);
  };

  useEffect(() => {
    if (inputs.noOfGuarantors > 0) {
      if (inputs.noOfCorpGuarantors > 0) {
        setInputs({
          ...inputs,
          useCorpSwitch: true,
          usePGSwitch: false,
        });
      } else {
        setInputs({
          ...inputs,
          useCorpSwitch: false,
          usePGSwitch: true,
        });
      }
    } else {
      setInputs({
        ...inputs,
        useCorpSwitch: true,
        usePGSwitch: false,
      });
    }
  }, [inputs.noOfCorpGuarantors, inputs.noOfGuarantors]);

  const [failedRules, setFailedRules] = useState([]);
  const [criteriaMessage, setCriteriaMessage] = useState("");
  const [showCriteriaModal, setShowCriteriaModal] = useState(false);
  const [acceptOverride, setAcceptOverride] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [modifiedFields, setModifiedFields] = useState({});

  const failCriteria = (title, checks = []) => ({
    title,
    checks, // optional array of { label, value, isValid }
  });

  const checkCriteria = () => {
    const failures = [];

    // Reset all rule overrides to 0
    setInputs((prev) => ({
      ...prev,
      fieldsModified: 0,
      requiresPersonalGuarantor: 0,
      corpThreeOfFourCriteriaFailed: 0,
      corpOneOfTwoCriteriaFailed: 0,
      loanShortfallSupportFailed: 0,
    }));

    // Check for modified fields first
    if (Object.keys(modifiedFields).length > 0) {
      setInputs((prev) => ({ ...prev, fieldsModified: 1 }));
      const modifiedFieldsList = Object.entries(modifiedFields).map(
        ([field, { label, previousVal, newVal }]) => ({
          label: label || field,
          value: `${previousVal} → ${newVal || "null"}`,
          isModified: true,
        })
      );

      failures.push(
        failCriteria(
          "The following fields have been modified:",
          modifiedFieldsList
        )
      );
    }

    // Rule A
    if (inputs.timeInBusiness < 4 && inputs.noOfGuarantors < 1) {
      setInputs((prev) => ({ ...prev, requiresPersonalGuarantor: 1 }));
      failures.push(
        failCriteria("Time in business < 4 years, need Personal Guarantor.", [
          {
            label: "Time in Business",
            value: inputs.timeInBusiness || 0,
            isValid: inputs.timeInBusiness >= 4,
          },
          {
            label: "No. of Guarantors" || 0,
            value: inputs.noOfGuarantors,
            isValid: inputs.noOfGuarantors >= 1,
          },
        ])
      );
    }

    if (inputs.loanAmount > 100000) {
      if (inputs.useCorpSwitch) {
        // Rule 1
        const checks1 = [
          {
            label: "Employees ≥ 50",
            value: inputs.numberOfEmployees || 0,
            isValid: inputs.numberOfEmployees >= 50,
          },
          {
            label: "Time in Business ≥ 10",
            value: inputs.timeInBusiness || 0,
            isValid: inputs.timeInBusiness >= 10,
          },
          {
            label: "Paydex ≥ 70",
            value: inputs.paydex || 0,
            isValid: inputs.paydex >= 70,
          },
          {
            label: "Trades of Paynet ≥ 5",
            value: inputs.pnNoOfTradeExperiences || 0,
            isValid: inputs.pnNoOfTradeExperiences >= 5,
          },
        ];
        if (checks1.filter((c) => c.isValid).length < 3) {
          setInputs((prev) => ({ ...prev, corpThreeOfFourCriteriaFailed: 1 }));
          failures.push(
            failCriteria(
              "Must fulfil at least 3 of these 4 conditions",
              checks1
            )
          );
        }

        // Rule 2
        const checks2 = [
          {
            label: "High Credit ≥ Loan Amount",
            value: `${inputs.highCredit || 0} / ${inputs.loanAmount}`,
            isValid: inputs.highCredit >= inputs.loanAmount,
          },
          {
            label: "PN High Credit ≥ Loan Amount",
            value: `${inputs.pnHighCredit || 0} / ${inputs.loanAmount}`,
            isValid: inputs.pnHighCredit >= inputs.loanAmount,
          },
        ];
        if (!checks2.some((c) => c.isValid)) {
          setInputs((prev) => ({ ...prev, corpOneOfTwoCriteriaFailed: 1 }));
          failures.push(
            failCriteria(
              "Must fulfil 1 of these 2 conditions (Corp Only)",
              checks2
            )
          );
        }
      }

      // Rule 3
      if (inputs.highCredit < inputs.loanAmount) {
        const checks3 = [
          {
            label: "No. of Guarantors > 0",
            value: inputs.noOfGuarantors || 0,
            isValid: inputs.noOfGuarantors > 0,
          },
          {
            label: "FICO > 725",
            value: inputs.fico || 0,
            isValid: inputs.fico > 725,
          },
          {
            label: "Real Estate > 0",
            value: inputs.realState || 0,
            isValid: inputs.realState > 0,
          },
          {
            label: "Availability > 75%",
            value: inputs.availability || 0,
            isValid: inputs.availability > 75,
          },
        ];
        if (!checks3.every((c) => c.isValid)) {
          setInputs((prev) => ({ ...prev, loanShortfallSupportFailed: 1 }));
          failures.push(
            failCriteria(
              "High Credit < Loan Amount, must fulfil all these conditions",
              checks3
            )
          );
        }
      }
    }

    if (failures.length > 0) {
      setFailedRules(failures);
      setCriteriaMessage(failures[0]);
      setShowCriteriaModal(true);
      return false;
    }

    return true;
  };

  console.log("current step", currentStep);

  return (
    <>
      <LeftNav />
      <div className="main-wrapper loan-underwrite-header">
        <Header token={token} setCompany={setCompany} />
        <Steps currentStep={currentStep} />
        <div
          className="d-flex content-wrap"
          style={{ "--sidebarTopOffset": "-285px" }}
        >
          <main>
            {currentStep === "Loans" && (
              <div className="loan-underwrite">
                <div className="p-4">
                  {tableData ? (
                    <>
                      <div className="d-flex gap-5 align-items-center justify-content-between">
                        <Button
                          onClick={() => {
                            setCurrentStep("Application");
                            setInputs({
                              ...initialInputs,
                              useCorpSwitch: true,
                            });
                            setErrors({});
                            setShowAlert(false);
                          }}
                        >
                          Create
                        </Button>

                        <div className="d-flex align-items-center">
                          <Form.Label className="mb-0">Search:</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Application Number"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                fetchData();
                              }
                            }}
                            style={{ width: "200px" }}
                            required
                          />
                        </div>
                      </div>

                      <div className="datatable datatable-users list-table">
                        <MDBDataTable
                          striped
                          small
                          data={tableData}
                          paging={false}
                          searching={false}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="d-flex gap-5 align-items-center justify-content-between">
                      <Button
                        onClick={() => {
                          setCurrentStep("Application");
                          setInputs({ ...initialInputs, useCorpSwitch: true });
                          setErrors({});
                          setShowAlert(false);
                        }}
                      >
                        Create
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            )}
            {(currentStep === "Application" ||
              currentStep === "Score" ||
              currentStep === "Review" ||
              currentStep === "Underwrite") && (
              <div
                id="loan-underwrite"
                className="loan-underwrite loan-calculate"
                style={{
                  height: currentStep === "Underwrite" ? "0" : "auto",
                  overflow: currentStep === "Underwrite" ? "hidden" : "auto",
                }}
              >
                {isLoading && (
                  <div id="loading">
                    <img
                      src={require("./../assets/images/ai.gif")}
                      alt="Loading"
                      width="100"
                    />
                  </div>
                )}
                <Container fluid className="container-wrapper">
                  {showAlert && (
                    <div className="alert-msg">
                      <Container fluid>{alertMsg}</Container>
                    </div>
                  )}
                  <Form
                    id="customForm"
                    onSubmit={handleSubmit}
                    style={{
                      width: currentStep === "Underwrite" ? "1100px" : "auto",
                      minWidth:
                        currentStep === "Underwrite" ? "1100px" : "auto",
                      maxWidth:
                        currentStep === "Underwrite" ? "1100px" : "auto",
                    }}
                  >
                    {currentStep === "Application" && (
                      <>
                        <Row>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <Form.Label>Application Number</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter here"
                                name="applicationNumber"
                                value={inputs.applicationNumber || ""}
                                onChange={handleChange}
                                isInvalid={!!errors.applicationNumber}
                                disabled={isReadOnly}
                              />
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <Form.Label>Name of Business</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter here"
                                name="nameOfBusiness"
                                value={inputs.nameOfBusiness || ""}
                                onChange={handleChange}
                                disabled={isReadOnly}
                              />
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <Form.Label>Office Name</Form.Label>
                              <Form.Select
                                name="officeName"
                                value={inputs.officeName || ""}
                                onChange={handleChange}
                                disabled={isReadOnly}
                              >
                                <option disabled value="">
                                  -- Select --
                                </option>
                                {officeName.map((type) => (
                                  <option key={type} value={type}>
                                    {type}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <Form.Label>Loan Amount</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter here"
                                name="loanAmount"
                                value={inputs.loanAmount || ""}
                                onChange={handleChange}
                                isInvalid={!!errors.loanAmount}
                                disabled={isReadOnly}
                              />
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <Form.Label>Asset Type</Form.Label>
                              <Form.Select
                                name="assetType"
                                value={inputs.assetType || ""}
                                onChange={handleChange}
                                disabled={isReadOnly}
                                isInvalid={!!errors.assetType}
                              >
                                <option disabled value="">
                                  -- Select --
                                </option>
                                {assetTypes.map((type) => (
                                  <option key={type} value={type}>
                                    {type}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <Form.Label>City</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter here"
                                name="city"
                                value={inputs.city || ""}
                                onChange={handleChange}
                                disabled={isReadOnly}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        {currentStep === "Underwrite" && (
                          <div className="divider"></div>
                        )}

                        <Row>
                          <Col sm={12}>
                            <h5 className="mt-4 mb-3">Bureau Details | D&B</h5>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {"Average High Credit "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="highCredit"
                                  value={inputs.highCredit || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" High Credit "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="maxHighCredit"
                                  value={inputs.maxHighCredit || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Paydex "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="paydex"
                                  value={inputs.paydex || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Suits "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="suits"
                                  value={inputs.suits || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Liens "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="liens"
                                  value={inputs.liens || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Judgements "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="judgements"
                                  value={inputs.judgements || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Start Year "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="startYear"
                                  value={inputs.startYear || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Number of Trade Lines "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="noOfTradeExperiences"
                                  value={inputs.noOfTradeExperiences || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>

                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Bankruptcy "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="bankruptcy"
                                  value={inputs.bankruptcy || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" SIC Code "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="standardCode"
                                  value={inputs.standardCode || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Commercial Credit Score "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="commercialCreditScore"
                                  value={inputs.commercialCreditScore || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={12}>
                            <h5 className="mt-4 mb-3">
                              Bureau Details | Experian
                            </h5>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Birth Year "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="birthyear"
                                  value={inputs.birthyear || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>

                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Vantage "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="vantage"
                                  value={inputs.vantage || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>

                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Number of Satisfactory Accounts "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="noOfSatisfactoryAccounts"
                                  value={inputs.noOfSatisfactoryAccounts || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Number of Inquiries "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="noOfInquiries"
                                  value={inputs.noOfInquiries || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Was Delinquent "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="noOfTotalDelinquencies"
                                  value={inputs.noOfTotalDelinquencies || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>

                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Number of Delinquencies "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="noOfDelinquencies"
                                  value={inputs.noOfDelinquencies || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" FICO Score "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="fico"
                                  value={inputs.fico || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{"Max FICO Score "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="maxFico"
                                  value={inputs.maxFico || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" FICO2 Score "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="fico2"
                                  value={inputs.fico2 || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Total Revolving Balance "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="totalRevolvingBalance"
                                  value={inputs.totalRevolvingBalance || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>

                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Total Revolving Available "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="totalRevolvingAvailable"
                                  value={inputs.totalRevolvingAvailable || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Real Estate Balance "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="realStateBalance"
                                  value={inputs.realStateBalance || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                  required
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={12}>
                            <h5 className="mt-4 mb-3">
                              Bureau Details | Paynet
                            </h5>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" PN Master Score "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="pnMasterScore"
                                  value={inputs.pnMasterScore || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{"High Credit "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="pnHighCredit"
                                  value={inputs.pnHighCredit || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Number of Trade Lines "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="pnNoOfTradeExperiences"
                                  value={inputs.pnNoOfTradeExperiences || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={12}>
                            <h5 className="mt-4 mb-3">
                              Loan Application | LeaseWorks
                            </h5>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Personal Guarantors "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="noOfGuarantors"
                                  value={inputs.noOfGuarantors || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Corporate Guarantors "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="noOfCorpGuarantors"
                                  value={inputs.noOfCorpGuarantors || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Time In Business "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="timeInBusiness"
                                  value={inputs.timeInBusiness || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Number of Employees "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="numberOfEmployees"
                                  value={inputs.numberOfEmployees || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Yield "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="yield"
                                  value={inputs.yield || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly}
                                  placeholder="Enter here"
                                />
                              </InputGroup>
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    )}
                    {(currentStep === "Score" ||
                      currentStep === "Review" ||
                      currentStep === "Underwrite") && (
                      <>
                        <Row>
                          <Col
                            className="d-flex align-items-baseline gap-2"
                            sm={12}
                          >
                            <h5
                              className={`mb-3 ${
                                currentStep === "Underwrite" ? "mt-2" : "mt-4"
                              }`}
                            >
                              Personal Guarantor (PG) Details
                            </h5>
                            <label className="loan-calculate switch">
                              <input
                                type="checkbox"
                                onChange={handleChange}
                                disabled={
                                  isReadOnly || inputs.noOfGuarantors <= 0
                                }
                                name="usePGSwitch"
                                checked={inputs.usePGSwitch || false}
                              />
                              <span className="slider"></span>
                            </label>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <Form.Label>Time in Business</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Enter here"
                                name="pgTimeInBusiness"
                                value={inputs.pgTimeInBusiness || ""}
                                onChange={handleChange}
                                disabled={isReadOnly || !inputs.usePGSwitch}
                              />
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <Form.Label>FICO Score</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Enter here"
                                name="pgFicoScore"
                                value={inputs.pgFicoScore || ""}
                                onChange={handleChange}
                                disabled={isReadOnly || !inputs.usePGSwitch}
                              />
                            </Form.Group>
                          </Col>

                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Strong Payment History "}
                                  {currentStep !== "Underwrite" ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip-info">
                                          Paydex equal to or greater than 70 OR
                                          Multiple Lease Repayments on Paynet
                                        </Tooltip>
                                      }
                                    >
                                      <i className="bi bi-info-circle"></i>
                                    </OverlayTrigger>
                                  ) : null}
                                </Form.Label>

                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={isReadOnly || !inputs.usePGSwitch}
                                    name="pgStrongPaymentHistorySwitch"
                                    checked={
                                      inputs.pgStrongPaymentHistorySwitch ||
                                      false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.usePGSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      inputs.pgStrongPaymentHistorySwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    borderColor:
                                      inputs.pgStrongPaymentHistorySwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    color: inputs.pgStrongPaymentHistorySwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  +{inputs.pgStrongPaymentHistorySwitchPoints}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Acceptable Payment History "}
                                  {currentStep !== "Underwrite" ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip-info">
                                          Non-Derogatory Navitas Payment History
                                        </Tooltip>
                                      }
                                    >
                                      <i className="bi bi-info-circle"></i>
                                    </OverlayTrigger>
                                  ) : null}
                                </Form.Label>

                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={isReadOnly || !inputs.usePGSwitch}
                                    name="pgAcceptableCreditHistorySwitch"
                                    checked={
                                      inputs.pgAcceptableCreditHistorySwitch ||
                                      false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.usePGSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      inputs.pgAcceptableCreditHistorySwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    borderColor:
                                      inputs.pgAcceptableCreditHistorySwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    color:
                                      inputs.pgAcceptableCreditHistorySwitch
                                        ? "var(--colorWhite)"
                                        : "var(--colorGray)",
                                  }}
                                >
                                  +
                                  {
                                    inputs.pgAcceptableComparibleCreditSwitchPoints
                                  }
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Strong Comparible Credit "}
                                  {currentStep !== "Underwrite" ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip-info">
                                          2x Requested Amount in D&B, Paynet or
                                          any Loan (Except Mortgage) on CBR
                                        </Tooltip>
                                      }
                                    >
                                      <i className="bi bi-info-circle"></i>
                                    </OverlayTrigger>
                                  ) : null}
                                </Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={isReadOnly || !inputs.usePGSwitch}
                                    name="pgStrongComparibleCreditSwitch"
                                    checked={
                                      inputs.pgStrongComparibleCreditSwitch ||
                                      false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.usePGSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      inputs.pgStrongComparibleCreditSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    borderColor:
                                      inputs.pgStrongComparibleCreditSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    color: inputs.pgStrongComparibleCreditSwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  +{inputs.pgStrongComparibleCreditSwitchPoints}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Acceptable Comparible Credit "}
                                  {currentStep !== "Underwrite" ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip-info">
                                          Similar Amount in any Bureau (Except
                                          Mortgage)
                                        </Tooltip>
                                      }
                                    >
                                      <i className="bi bi-info-circle"></i>
                                    </OverlayTrigger>
                                  ) : null}
                                </Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={isReadOnly || !inputs.usePGSwitch}
                                    name="pgAcceptableComparibleCreditSwitch"
                                    checked={
                                      inputs.pgAcceptableComparibleCreditSwitch ||
                                      false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.usePGSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      inputs.pgAcceptableComparibleCreditSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    borderColor:
                                      inputs.pgAcceptableComparibleCreditSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    color:
                                      inputs.pgAcceptableComparibleCreditSwitch
                                        ? "var(--colorWhite)"
                                        : "var(--colorGray)",
                                  }}
                                >
                                  +
                                  {
                                    inputs.pgAcceptableComparibleCreditSwitchPoints
                                  }
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Preferred Collateral "}
                                  {currentStep !== "Underwrite" ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip-info">
                                          Copiers, Computers, Telecom Hardware,
                                          Medical, Automotive or any Hard Asset
                                        </Tooltip>
                                      }
                                    >
                                      <i className="bi bi-info-circle"></i>
                                    </OverlayTrigger>
                                  ) : null}
                                </Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={isReadOnly || !inputs.usePGSwitch}
                                    name="pgPreferredCollateralSwitch"
                                    checked={
                                      inputs.pgPreferredCollateralSwitch ||
                                      false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.usePGSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      inputs.pgPreferredCollateralSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    borderColor:
                                      inputs.pgPreferredCollateralSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    color: inputs.pgPreferredCollateralSwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  +{inputs.pgPreferredCollateralSwitchPoints}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Soft Collateral "}
                                  {currentStep !== "Underwrite" ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip-info">
                                          Security Systems, Software, Low
                                          Correlation New Technology
                                        </Tooltip>
                                      }
                                    >
                                      <i className="bi bi-info-circle"></i>
                                    </OverlayTrigger>
                                  ) : null}
                                </Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={isReadOnly || !inputs.usePGSwitch}
                                    name="pgSoftCollateralSwitch"
                                    checked={
                                      inputs.pgSoftCollateralSwitch || false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.usePGSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      inputs.pgSoftCollateralSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    borderColor: inputs.pgSoftCollateralSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    color: inputs.pgSoftCollateralSwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  {inputs.pgSoftCollateralSwitchPoints}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Intangibles "}
                                  {currentStep !== "Underwrite" ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip-info">
                                          Fins, Resume, High Scores, Banks,
                                          Other
                                        </Tooltip>
                                      }
                                    >
                                      <i className="bi bi-info-circle"></i>
                                    </OverlayTrigger>
                                  ) : null}
                                </Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={isReadOnly || !inputs.usePGSwitch}
                                    name="pgIntangiblesSwitch"
                                    checked={
                                      inputs.pgIntangiblesSwitch || false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup style={{ width: "100px" }}>
                                <Form.Control
                                  type="number"
                                  name="pgIntangiblesPoints"
                                  value={inputs.pgIntangiblesPoints || ""}
                                  onChange={handleChange}
                                  disabled={
                                    isReadOnly ||
                                    !inputs.usePGSwitch ||
                                    !inputs.pgIntangiblesSwitch
                                  }
                                  style={{ width: "50px" }}
                                />
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.usePGSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor: inputs.pgIntangiblesSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    borderColor: inputs.pgIntangiblesSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    color: inputs.pgIntangiblesSwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  +{inputs.pgIntangiblesPoints || 0}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Override "}</Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={isReadOnly || !inputs.usePGSwitch}
                                    name="pgOverrideSwitch"
                                    checked={inputs.pgOverrideSwitch || false}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <div className="d-flex">
                                <Form.Control
                                  type="text"
                                  placeholder="Explain override"
                                  name="pgOverrideText"
                                  value={inputs.pgOverrideText || ""}
                                  onChange={handleChange}
                                  disabled={
                                    isReadOnly ||
                                    !inputs.usePGSwitch ||
                                    !inputs.pgOverrideSwitch
                                  }
                                  isInvalid={
                                    inputs.pgOverrideSwitch &&
                                    !!errors.pgOverrideText
                                  }
                                  style={{
                                    flex: 1, // grow to fill remaining space
                                    marginRight: "0.5rem", // small spacing before InputGroup
                                  }}
                                />
                                <InputGroup
                                  className="d-flex"
                                  style={{ width: "100px" }}
                                >
                                  <Form.Control
                                    type="number"
                                    name="pgOverridePoints"
                                    value={inputs.pgOverridePoints || ""}
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly ||
                                      !inputs.usePGSwitch ||
                                      !inputs.pgOverrideSwitch
                                    }
                                    style={{ flex: "0 0 50%" }}
                                  />
                                  <InputGroup.Text
                                    className={`input-group-text ${
                                      isReadOnly || !inputs.usePGSwitch
                                        ? "read-only"
                                        : ""
                                    }`}
                                    style={{
                                      backgroundColor: inputs.pgOverrideSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                      borderColor: inputs.pgOverrideSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                      color: inputs.pgOverrideSwitch
                                        ? "var(--colorWhite)"
                                        : "var(--colorGray)",
                                      flex: "0 0 50%",
                                    }}
                                  >
                                    {inputs.pgOverridePoints > 0
                                      ? `+${inputs.pgOverridePoints}`
                                      : inputs.pgOverridePoints || "+0"}
                                  </InputGroup.Text>
                                </InputGroup>
                              </div>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Vendor "}
                                  {currentStep !== "Underwrite" ? (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip-info">
                                          Source of Transaction is Clear and
                                          Understood
                                        </Tooltip>
                                      }
                                    >
                                      <i className="bi bi-info-circle"></i>
                                    </OverlayTrigger>
                                  ) : null}
                                </Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={isReadOnly || !inputs.usePGSwitch}
                                    name="pgVendorCheck"
                                    checked={inputs.pgVendorCheck || false}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row>
                          <Col
                            className="d-flex align-items-baseline gap-2"
                            sm={12}
                          >
                            <h5 className="mt-4 mb-3">Corp Details</h5>
                            <label className="loan-calculate switch">
                              <input
                                type="checkbox"
                                onChange={handleChange}
                                disabled={isReadOnly}
                                name="useCorpSwitch"
                                checked={inputs.useCorpSwitch || false}
                              />
                              <span className="slider"></span>
                            </label>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Time in Business "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="corpTimeInBusiness"
                                  value={inputs.corpTimeInBusiness || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly || !inputs.useCorpSwitch}
                                  placeholder="Enter here"
                                  style={{ width: "50px" }}
                                />
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                >
                                  +{inputs.corpTimeInBusinessPoints || 0}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Number of Employees "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="corpNumberOfEmployees"
                                  value={inputs.corpNumberOfEmployees || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly || !inputs.useCorpSwitch}
                                  placeholder="Enter here"
                                  style={{ width: "50px" }}
                                />
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                >
                                  +{inputs.corpNumberOfEmployeesPoints || 0}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" High Credit "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="corpHighCredit"
                                  value={inputs.corpHighCredit || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly || !inputs.useCorpSwitch}
                                  placeholder="Enter here"
                                  style={{ width: "50px" }}
                                />
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                >
                                  +{inputs.corpHighCreditPoints || 0}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Paydex "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="corpPaydex"
                                  value={inputs.corpPaydex || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly || !inputs.useCorpSwitch}
                                  placeholder="Enter here"
                                  style={{ width: "50px" }}
                                />
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                >
                                  {inputs.corpPaydexPoints >= 0
                                    ? `+${inputs.corpPaydexPoints || 0}`
                                    : inputs.corpPaydexPoints || 0}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Trade Lines "}</Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  name="corpTradeLines"
                                  value={inputs.corpTradeLines || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly || !inputs.useCorpSwitch}
                                  placeholder="Enter here"
                                  style={{ width: "50px" }}
                                />
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                >
                                  +{inputs.corpTradeLinesPoints || 0}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Suits/Liens/Judgments "}
                                </Form.Label>
                              </div>
                              <InputGroup>
                                <Form.Select
                                  name="suitsLiensJudgements"
                                  value={inputs.suitsLiensJudgements || ""}
                                  onChange={handleChange}
                                  disabled={isReadOnly || !inputs.useCorpSwitch}
                                  style={{ width: "50px" }}
                                >
                                  <option disabled value="">
                                    -- Select --
                                  </option>
                                  <option value="none">None</option>
                                  <option value="any">Any</option>
                                  <option value="material">Material</option>
                                </Form.Select>
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                >
                                  {inputs.suitsLiensJudgementsPoints >= 0
                                    ? `+${
                                        inputs.suitsLiensJudgementsPoints || 0
                                      }`
                                    : inputs.suitsLiensJudgementsPoints || 0}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" History Clear "}</Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly || !inputs.useCorpSwitch
                                    }
                                    name="historyClearSwitch"
                                    checked={inputs.historyClearSwitch || false}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor: inputs.historyClearSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    borderColor: inputs.historyClearSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    color: inputs.historyClearSwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  +{inputs.historyClearPoints}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" UCC Filings "}</Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly || !inputs.useCorpSwitch
                                    }
                                    name="uccFilingsSwitch"
                                    checked={inputs.uccFilingsSwitch || false}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor: inputs.uccFilingsSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    borderColor: inputs.uccFilingsSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    color: inputs.uccFilingsSwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  +{inputs.uccFilingsPoints}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" High Risk Industry "}
                                </Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly || !inputs.useCorpSwitch
                                    }
                                    name="highRiskIndustrySwitch"
                                    checked={
                                      inputs.highRiskIndustrySwitch || false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      inputs.highRiskIndustrySwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    borderColor: inputs.highRiskIndustrySwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    color: inputs.highRiskIndustrySwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  {inputs.highRiskIndustryPoints}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Comparable Lease "}</Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly || !inputs.useCorpSwitch
                                    }
                                    name="comparableLeaseSwitch"
                                    checked={
                                      inputs.comparableLeaseSwitch || false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      inputs.comparableLeaseSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    borderColor: inputs.comparableLeaseSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    color: inputs.comparableLeaseSwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  +{inputs.comparableLeasePoints}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Majority Equity Single Ownership "}
                                </Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly || !inputs.useCorpSwitch
                                    }
                                    name="majorityEquitySingleOwnershipSwitch"
                                    checked={
                                      inputs.majorityEquitySingleOwnershipSwitch ||
                                      false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      inputs.majorityEquitySingleOwnershipSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    borderColor:
                                      inputs.majorityEquitySingleOwnershipSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    color:
                                      inputs.majorityEquitySingleOwnershipSwitch
                                        ? "var(--colorWhite)"
                                        : "var(--colorGray)",
                                  }}
                                >
                                  {inputs.majorityEquitySingleOwnershipPoints}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>
                                  {" Preferred Collateral "}
                                </Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly || !inputs.useCorpSwitch
                                    }
                                    name="preferredCollateralSwitch"
                                    checked={
                                      inputs.preferredCollateralSwitch || false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor:
                                      inputs.preferredCollateralSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    borderColor:
                                      inputs.preferredCollateralSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                    color: inputs.preferredCollateralSwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  +{inputs.preferredCollateralPoints}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4 align-items-center gap-2">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Soft Collateral "}</Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly || !inputs.useCorpSwitch
                                    }
                                    name="softCollateralSwitch"
                                    checked={
                                      inputs.softCollateralSwitch || false
                                    }
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup className="d-flex align-items-center">
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor: inputs.softCollateralSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    borderColor: inputs.softCollateralSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    color: inputs.softCollateralSwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  {inputs.softCollateralPoints}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Intangibles "}</Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly || !inputs.useCorpSwitch
                                    }
                                    name="intangiblesSwitch"
                                    checked={inputs.intangiblesSwitch || false}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <InputGroup style={{ width: "100px" }}>
                                <Form.Control
                                  type="number"
                                  name="intangiblesPoints"
                                  value={inputs.intangiblesPoints || ""}
                                  onChange={handleChange}
                                  disabled={
                                    isReadOnly ||
                                    !inputs.useCorpSwitch ||
                                    !inputs.intangiblesSwitch
                                  }
                                  style={{ width: "50px" }}
                                />
                                <InputGroup.Text
                                  className={`input-group-text ${
                                    isReadOnly || !inputs.useCorpSwitch
                                      ? "read-only"
                                      : ""
                                  }`}
                                  style={{
                                    backgroundColor: inputs.intangiblesSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    borderColor: inputs.intangiblesSwitch
                                      ? "var(--colorYellow)"
                                      : "var(--color2)",
                                    color: inputs.intangiblesSwitch
                                      ? "var(--colorWhite)"
                                      : "var(--colorGray)",
                                  }}
                                >
                                  +{inputs.intangiblesPoints || 0}
                                </InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Vendor "}</Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly || !inputs.useCorpSwitch
                                    }
                                    name="vendorCheck"
                                    checked={inputs.vendorCheck || false}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Override "}</Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly || !inputs.useCorpSwitch
                                    }
                                    name="overrideSwitch"
                                    checked={inputs.overrideSwitch || false}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <div className="d-flex">
                                <Form.Control
                                  type="text"
                                  placeholder="Explain override"
                                  name="overrideText"
                                  value={inputs.overrideText || ""}
                                  onChange={handleChange}
                                  disabled={
                                    isReadOnly ||
                                    !inputs.useCorpSwitch ||
                                    !inputs.overrideSwitch
                                  }
                                  isInvalid={
                                    inputs.overrideSwitch &&
                                    !!errors.overrideText
                                  }
                                  style={{
                                    flex: 1, // grow to fill remaining space
                                    marginRight: "0.5rem", // small spacing before InputGroup
                                  }}
                                />
                                <InputGroup
                                  className="d-flex"
                                  style={{ width: "100px" }}
                                >
                                  <Form.Control
                                    type="number"
                                    name="overridePoints"
                                    value={inputs.overridePoints || ""}
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly ||
                                      !inputs.useCorpSwitch ||
                                      !inputs.overrideSwitch
                                    }
                                    style={{ flex: "0 0 50%" }}
                                  />
                                  <InputGroup.Text
                                    className={`input-group-text ${
                                      isReadOnly || !inputs.useCorpSwitch
                                        ? "read-only"
                                        : ""
                                    }`}
                                    style={{
                                      backgroundColor: inputs.overrideSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                      borderColor: inputs.overrideSwitch
                                        ? "var(--colorYellow)"
                                        : "var(--color2)",
                                      color: inputs.overrideSwitch
                                        ? "var(--colorWhite)"
                                        : "var(--colorGray)",
                                      flex: "0 0 50%",
                                    }}
                                  >
                                    {inputs.overridePoints > 0
                                      ? `+${inputs.overridePoints}`
                                      : inputs.overridePoints || "+0"}
                                  </InputGroup.Text>
                                </InputGroup>
                              </div>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>
                            <Form.Group className="mb-4">
                              <div className="d-flex align-items-center gap-2">
                                <Form.Label>{" Any Major Derog "}</Form.Label>
                                <label className="loan-calculate switch">
                                  <input
                                    type="checkbox"
                                    onChange={handleChange}
                                    disabled={
                                      isReadOnly || !inputs.useCorpSwitch
                                    }
                                    name="anyMajorDerog"
                                    checked={inputs.anyMajorDerog || false}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    )}
                    {currentStep === "Underwrite" && (
                      <div className="divider"></div>
                    )}
                    {/* Buttons */}
                    <Row
                      className="flex justify-content-end"
                      style={{
                        display: currentStep === "Underwrite" ? "none" : "flex",
                      }}
                    >
                      <Col sm="4" className="d-flex">
                        <Button
                          variant="transparent"
                          className="mt-4 mb-5 w-50"
                          type="button"
                          onClick={() => {
                            if (currentStep === "Application") {
                              setCurrentStep("Loans");
                              setModifiedFields({});
                            } else if (currentStep === "Score") {
                              setCurrentStep("Application");
                            } else if (currentStep === "Review") {
                              setCurrentStep("Score");
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            }
                          }}
                        >
                          Back
                        </Button>
                        <Button
                          variant="primary"
                          className="mt-4 mb-5 ms-3 w-50"
                          type="button"
                          disabled={
                            currentStep === "Score" &&
                            !inputs.useCorpSwitch &&
                            !inputs.usePGSwitch
                          }
                          onClick={async () => {
                            if (currentStep === "Application") {
                              try {
                                await logWorkflowAction(
                                  inputs.applicationNumber,
                                  "score",
                                  inputs
                                );
                              } catch (error) {
                                console.error(
                                  "Error logging score loan action:",
                                  error
                                );
                              }
                              const fieldLabels = {
                                applicationNumber: "Application Number",
                                loanAmount: "Loan Amount",
                                assetType: "Asset Type",
                              };

                              const dynamicLabels = {
                                pgOverrideText: "Override Text",
                                overrideText: "Override Text",
                              };

                              const requiredFields = Object.keys(fieldLabels);

                              if (inputs.pgOverrideSwitch) {
                                requiredFields.push("pgOverrideText");
                              }
                              if (inputs.overrideSwitch) {
                                requiredFields.push("overrideText");
                              }

                              const newErrors = {};
                              let firstEmpty = null;

                              requiredFields.forEach((field) => {
                                const label =
                                  fieldLabels[field] ||
                                  dynamicLabels[field] ||
                                  field;
                                console.log(
                                  fieldLabels[field] ||
                                    dynamicLabels[field] ||
                                    field
                                );
                                if (!inputs[field]) {
                                  newErrors[field] = `${label} is required!`;
                                  if (!firstEmpty) firstEmpty = field; // capture first empty
                                }
                              });

                              setErrors(newErrors);

                              if (Object.keys(newErrors).length > 0) {
                                const label =
                                  fieldLabels[firstEmpty] ||
                                  dynamicLabels[firstEmpty] ||
                                  firstEmpty;
                                setAlertMsg(`${label} is required!`);
                                setShowAlert(true);
                                return; // stop progression
                              }

                              setErrors({});
                              setShowAlert(false);

                              setCurrentStep("Score");
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            } else if (currentStep === "Score") {
                              const canContinue = checkCriteria();
                              if (!canContinue) return; // show modal instead of moving forward
                              try {
                                await logWorkflowAction(
                                  inputs.applicationNumber,
                                  "review",
                                  inputs
                                );
                              } catch (error) {
                                console.error(
                                  "Error logging review loan action:",
                                  error
                                );
                              }
                              setCurrentStep("Review");
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            } else if (currentStep === "Review") {
                              try {
                                await logWorkflowAction(
                                  inputs.applicationNumber,
                                  "underwrite",
                                  inputs
                                );
                              } catch (error) {
                                console.error(
                                  "Error logging underwrite loan action:",
                                  error
                                );
                              }
                              setCurrentStep("Underwrite");
                            }
                          }}
                        >
                          {currentStep === "Application"
                            ? "Score"
                            : currentStep === "Score"
                            ? "Review"
                            : "Underwrite"}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Container>
              </div>
            )}
            {currentStep === "Underwrite" && (
              <UnderwriteLoan
                applicationInputs={inputs}
                setCurrentStep={setCurrentStep}
              />
            )}
            <Modal
              className="loan-underwrite"
              show={showCriteriaModal}
              onHide={() => {
                setShowCriteriaModal(false);
                setAcceptOverride(false); // reset checkbox
              }}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {criteriaMessage.checks &&
                  criteriaMessage.checks.some((c) => c.isModified)
                    ? "Loan Application Alert"
                    : "Credit Policy Alert"}
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <h6 className="mb-3">{criteriaMessage.title}</h6>

                {criteriaMessage.checks && (
                  <ul className="list-unstyled mb-0">
                    {criteriaMessage.checks.map((c, idx) => (
                      <li
                        key={idx}
                        className={`d-flex justify-content-between align-items-center py-2 px-3 mb-2 ${
                          c.isModified
                            ? ""
                            : c.isValid
                            ? "text-success"
                            : "text-danger"
                        }`}
                        style={{
                          border: "1px solid",
                          color: c.isModified ? "#FD9F29" : "",
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <span style={{ marginRight: "8px" }}>
                            {c.isModified ? (
                              <i className="fas fa-exclamation" />
                            ) : c.isValid ? (
                              <i className="fas fa-check" />
                            ) : (
                              <i className="fas fa-times" />
                            )}
                          </span>
                          <strong>{c.label}</strong>
                        </div>
                        <span>{c.value}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </Modal.Body>

              <Modal.Footer className="flex-column align-items-start">
                <div className="form-check mb-2">
                  <input
                    type="checkbox"
                    id="acceptOverride"
                    className="form-check-input"
                    checked={acceptOverride}
                    onChange={(e) => setAcceptOverride(e.target.checked)}
                  />
                  <label htmlFor="acceptOverride" className="form-check-label">
                    {criteriaMessage.checks &&
                    criteriaMessage.checks.some((c) => c.isModified)
                      ? "I accept and agree to update the loan application data."
                      : "I accept and agree to override the credit policy alert."}
                  </label>
                </div>

                <div className="d-flex justify-content-end w-100">
                  <Button
                    variant="transparent"
                    onClick={() => {
                      setShowCriteriaModal(false);
                      setAcceptOverride(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    className="ms-2"
                    disabled={!acceptOverride}
                    onClick={async () => {
                      const remaining = failedRules.slice(1);
                      if (remaining.length > 0) {
                        setFailedRules(remaining);
                        setCriteriaMessage(remaining[0]);
                        setAcceptOverride(false); // reset for next modal
                      } else {
                        setShowCriteriaModal(false);
                        setCurrentStep("Review");
                        try {
                          await logWorkflowAction(
                            inputs.applicationNumber,
                            "review",
                            inputs
                          );
                        } catch (error) {
                          console.error(
                            "Error logging review loan action:",
                            error
                          );
                        }
                        window.scrollTo({ top: 0, behavior: "smooth" });
                        setAcceptOverride(false);
                      }
                    }}
                  >
                    {failedRules.length > 1 ? "Next" : "Override & Continue"}
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          </main>
          <RightAside>
            <ContentPage embedded={true} />
            <a
              href="/content-page"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                position: "sticky",
                float: "right",
                right: "10px",
                bottom: "10px",
              }}
              title="Open in new tab"
            >
              <img
                src={require("./../assets/images/icons/arrow-up-right-from-square.png")}
                width="20"
                alt="Open in new tab"
              />
            </a>
          </RightAside>
        </div>
      </div>
    </>
  );
};

export default LoanCalculate;
